import TableWidget from "csi/table/Widget";
import { pathCreate } from "csi/utility/pathUtility";
import Search from "csi/xml/Search";
import declare from "dojo/_base/declare";

export = declare(TableWidget, {
	/** the spec items  */
	specItems: null,

	/**
	 * @override
	 * Grab all the spec items as the column nodes for the matrix
	 */
	onViewStart(dfds: PromiseLike<any>[]): void {
		const hasSpecItemMatrix = this.attributeSpecs.find({
			matrix: "VariantComponents",
			name: "SpecMatrix",
			path: "Child:VariantComponents",
		});
		const paths = [];

		if (hasSpecItemMatrix) {
			paths.push(pathCreate("ValueAttributeDefinition"));
		}

		// if the matrix is absent, query is not necessary anymore
		if (paths.length) {
			const retailProduct = this.getViewNode();
			const search = new Search().byType("SpecificationItemDefinition");
			search.addParameter("Fmt.Attr.List", "SpecificationItemDefinition:Node Name;SysID;UDCMatrixSortCode;ValueAttributeDefinition", true);
			search.setLimitPath(retailProduct.$URL, pathCreate("RetailVariants", "VariantComponents", "Component", "SharedSpecSections", "SectionItems", "Definition"));
			search.addDependencyPaths(paths);
			search.getQuery().SortByAttr("UDCMatrixSortCode");

			dfds.push(search.execute().then((response) => {
				this.cacheView.cacheResponse(response);
				this.specItems = response.getResultNodes() || [];
			}));
		}
	},
});